import { RevisionResponse } from '@/custom/menicon/models';
import { GenericService } from '@/services/api/generic.service';

export class PrescriptionHistoryService extends GenericService<RevisionResponse> {
  constructor(journeyId: string) {
    super(`/menicon/v1/journeys/${journeyId}/history`);
  }
}
